module.exports = __webpack_public_path__ + "img/search.fa82eaa1.svg";